import i18nFactory from '@yandex-int/i18n';
import { createSelector } from 'reselect';

import { FooterLinkId } from '../../components/Footer/Footer';
import { getValueFromApiFormat } from '../../mappers/common/common';
import { getContacts } from '../../mappers/footer/footer';
import { UrlHelpers } from '../../service/UrlHelpers';
import { ClientProperties, FooterData, OperatorData, Tld } from '../../typings/common';
import { State } from '../../typings/state';

import * as keyset from './footer.i18n';

const i18n = i18nFactory(keyset);

export const selectFooterLangRetPath = createSelector(
    (state: State) => state.router,
    () => {
        return UrlHelpers.getRetPath();
    }
);

export const selectCopyrightStartYear = createSelector(
    (state: State) => state.commonData.tld,
    (tld: Tld): number => {
        const isTurkey = tld === Tld.comTr;

        return isTurkey ? 2011 : 2001;
    }
);

export const selectFooterLinks = createSelector(
    (state: State) => state.commonData.tld,
    (state: State) => state.commonData.client,
    (state: State) => state.commonData.operator,
    (tld: Tld, client: ClientProperties, operator: OperatorData): Array<FooterLinkId> => {
        const links: Array<FooterLinkId> = [];
        const isTurkey = tld === Tld.comTr;

        if (operator.isSelfAgency) {
            links.push(FooterLinkId.selfAgencyHelpLink);
        } else if (client.agencyInfo) {
            links.push(FooterLinkId.agencyClientHelpLink);
        } else {
            links.push(FooterLinkId.commonHelpLink);
        }

        if (!isTurkey) {
            links.push(FooterLinkId.advertisement);
        }

        return links;
    }
);

// todo: DIRECT-96877 этому методу здесь не место,
// его надо вынести в commonData и отрефакторить
export const selectFooterData = createSelector(
    (state: State) => state.commonData.operator,
    (state: State) => state.commonData.client,
    (operator, client): FooterData => {
        const managersInfo = client.managersInfo || [];
        const manager = managersInfo[0] ||
            client.agencyInfo || {
                name: '',
                phone: '',
                email: ''
            };

        const isManager = managersInfo.length > 0;

        return {
            manager: {
                name: manager.name ? `${isManager ? i18n('manager:') : i18n('agency:')} ${manager.name}` : '',
                tel: getValueFromApiFormat(manager.phone),
                email: manager.email,
                representativeName: client.agencyInfo ? client.agencyInfo.representativeName : undefined
            },
            contacts: getContacts(operator.officeInfo)
        };
    }
);
